<script>
import { mapState } from 'vuex'
import MemberProfileForm from '@components/member-profile-form'
import MemberPasswordForm from '@components/member-password-form'

export default {
  page: {
    title: 'Member Profile',
    meta: [{ name: 'description', content: 'Member Profile' }],
  },

  components: { MemberProfileForm, MemberPasswordForm },

  props: {
    property: { type: Object, required: true },
    dropdown: { type: Object, required: true },
  },

  computed: {
    ...mapState('auth', { user: 'currentUser' }),
  },
}
</script>

<template>
  <section class="mt-6">
    <div class="container container-page mx-auto px-6">
      <div class="px-6">
        <BaseAlert />
      </div>
      <div class="flex flex-wrap -mx-3">
        <div class="w-full md:w-1/2 mb-6 px-3">
          <MemberProfileForm :user="user" :dropdown="dropdown" />
        </div>
        <!-- profile -->

        <div class="w-full md:w-1/2 mb-6 px-3">
          <MemberPasswordForm />
        </div>
        <!-- change password -->
      </div>
    </div>
  </section>
</template>
